import { useGetAssignedPostsInfinite } from '@repo/api/post/useGetAssignedPostsInfinite';

import HomeCalendarSchedule from '@/components/features/home/HomeCalendarSchedule';
import HomeCreatePost from '@/components/features/home/HomeCreatePost';
import HomeHeader from '@/components/features/home/HomeHeader';
import PostList from '@/components/features/post/PostList';
import { useMediaQuery } from '@/hooks/media-query';
import { useCredentials } from '@/store/auth-store';

export default function HomePage() {
  const isLaptop = useMediaQuery('lg');
  const { lvl } = useCredentials();
  const isAdmin: boolean = lvl === 2;

  const query = useGetAssignedPostsInfinite();
  return (
    <div className={'base-direction-row'}>
      <div className={'flex flex-1 flex-col gap-4'}>
        <HomeHeader />
        {!isLaptop ? <HomeCalendarSchedule mode={'mobile'} /> : null}
        <div className={'flex w-full flex-1 flex-col items-center gap-5'}>
          {isAdmin ? <HomeCreatePost /> : null}
          <PostList query={query} />
        </div>
      </div>
      {isLaptop ? <HomeCalendarSchedule mode={'desktop'} /> : null}
    </div>
  );
}
